var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.125C8.25 4.77982 8.52982 4.5 8.875 4.5H18.875C19.2202 4.5 19.5 4.77982 19.5 5.125V15.125C19.5 15.4702 19.2202 15.75 18.875 15.75H15.125C14.7798 15.75 14.5 15.4702 14.5 15.125C14.5 14.7798 14.7798 14.5 15.125 14.5H18.25V5.75H9.5V8.875C9.5 9.22018 9.22018 9.5 8.875 9.5C8.52982 9.5 8.25 9.22018 8.25 8.875V5.125Z",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.875C4.5 8.52982 4.77982 8.25 5.125 8.25H15.125C15.4702 8.25 15.75 8.52982 15.75 8.875V18.875C15.75 19.2202 15.4702 19.5 15.125 19.5H5.125C4.77982 19.5 4.5 19.2202 4.5 18.875V8.875ZM5.75 9.5V18.25H14.5V9.5H5.75Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyShape);
export default __webpack_public_path__ + "static/media/copy-shape.108f99800dde3832e763752a31658207.svg";
export { ForwardRef as ReactComponent };